export function valuesAreEqual<T>(a: T, b: T): boolean {
  if (typeof a === 'object' && a !== null && typeof b === 'object' && b !== null) {
    return JSON.stringify(a) === JSON.stringify(b);
  }
  return a === b;
}

/** Same members by reference; `undefined` on either side is never equal. */
export function setsAreEqual<T>(a: Set<T> | undefined, b: Set<T> | undefined): boolean {
  if (!a || !b || a.size !== b.size) return false;
  return Array.from(a).every((value) => b.has(value));
}
